export default __webpack_public_path__ + "2cef9ca.png";